import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {zadPromoCodeGenerateUrl, zadPromoCodeStatusUrl, zadPromoCodesUrl} from '../../api'
import {buildZadListQuery} from '../zad/query'
import {parseZadApiError} from '../zad/errors'
import {extractGeneratedPromoCode, extractPromoCodeItem, extractPromoCodeList} from '../zad/promotionHelpers'
import {
  CreateZadPromoCodeRequest,
  FetchZadPromoCodesRequest,
  GenerateZadPromoCodeRequest,
  UpdateZadPromoCodeStatusRequest,
} from './types'

function promoCodeResult(data: unknown) {
  return {
    success: true as const,
    item: extractPromoCodeItem(data),
  }
}

export const fetchZadPromoCodes = createAsyncThunk(
  'zadPromoCodes/fetch',
  async (payload: FetchZadPromoCodesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${zadPromoCodesUrl}?${buildZadListQuery({
          pageNumber: payload.pageNumber,
          pageCount: payload.pageCount,
        })}`
      )
      const list = extractPromoCodeList(res.data || {})
      return {
        success: true as const,
        items: list.items,
        total: list.total,
        totalPages: list.totalPages,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const createZadPromoCode = createAsyncThunk(
  'zadPromoCodes/create',
  async (payload: CreateZadPromoCodeRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadPromoCodesUrl, payload.body)
      return promoCodeResult(res.data)
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadPromoCodeStatus = createAsyncThunk(
  'zadPromoCodes/updateStatus',
  async (payload: UpdateZadPromoCodeStatusRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadPromoCodeStatusUrl(payload.id), {
        isActive: payload.isActive,
      })
      return promoCodeResult(res.data)
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const generateZadPromoCode = createAsyncThunk(
  'zadPromoCodes/generate',
  async (payload: GenerateZadPromoCodeRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadPromoCodeGenerateUrl, {
        prefix: payload.prefix || 'ZAD',
      })
      return {
        success: true as const,
        code: extractGeneratedPromoCode(res.data),
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
